import {
  GROWTH_CALCULATORS,
  PROJECT_TYPE_TO_PATH,
  PROJECTS_ROUTE,
} from 'spw-constants';
import { ITotalProgram, Scenario } from 'spw-redux/modules/calculators/types';
import {
  PROGRAMMING_BUILDING_VIEWS,
  SCENARIO_LIST_TYPES,
} from 'spw-components/project-details-tabs/building-details/constants';
import { IProject } from 'spw-redux/modules/projects/types';
import { isDepartmentsTypeScenario } from 'spw-shared/utils';
import { PlainProgramScenario } from '../../../models/Scenario';

export const isTotalProgram = (scenario: Scenario | PlainProgramScenario) =>
  scenario?.calculatorType === GROWTH_CALCULATORS.totalProgram;

export const getListTypeByScenario = (
  scenario: Scenario | PlainProgramScenario | ITotalProgram
) => {
  if (scenario.calculatorType === GROWTH_CALCULATORS.macroProgramming) {
    return SCENARIO_LIST_TYPES.MACRO;
  }

  if (
    [
      GROWTH_CALCULATORS.floorHeadcountSeatcount,
      GROWTH_CALCULATORS.floorUsf,
    ].includes(scenario.calculatorType)
  ) {
    return SCENARIO_LIST_TYPES.FLOOR;
  }

  if (isDepartmentsTypeScenario(scenario)) {
    return SCENARIO_LIST_TYPES.DEPARTMENTS;
  }

  return SCENARIO_LIST_TYPES.BUILDING;
};

export const getScenarioListLocation = (
  project: IProject,
  scenario: Scenario | PlainProgramScenario | ITotalProgram
) => {
  const pathname = `${PROJECTS_ROUTE}/${PROJECT_TYPE_TO_PATH[project.type]}/${
    project.id
  }/building`;

  const location = {
    pathname: `${pathname}/${PROGRAMMING_BUILDING_VIEWS.SCENARIOS}`,
    search: `type=${getListTypeByScenario(scenario)}`,
  };

  if (
    [
      GROWTH_CALCULATORS.floorHeadcountSeatcount,
      GROWTH_CALCULATORS.floorUsf,
    ].includes(scenario.calculatorType)
  ) {
    location.search = `${location.search}&floor_id=${
      (scenario as Scenario | PlainProgramScenario).floorId
    }`;
  }

  return location;
};
